import { CanceledError, type AxiosRequestConfig } from 'axios';
import { captureSession } from '@/lib/session-snapshot';

type Permit = () => { url: string; method: string; context: string | null };
declare module 'axios' {
  interface AxiosRequestConfig { sessionPermit?: Permit }
}
const issued = new WeakSet<Permit>();
const methods: Record<string, string> = {
  '/auth/me': 'get', '/auth/socket-token': 'post', '/auth/switch-clinic': 'post',
};

/** Function identity survives Axios config merging; arbitrary flags cannot bypass the barrier. */
export function sessionPermit(
  url: '/auth/me' | '/auth/socket-token' | '/auth/switch-clinic',
  context: string | null,
  assertCurrent: () => void,
): AxiosRequestConfig {
  if (!Object.prototype.hasOwnProperty.call(methods, url) || (url !== '/auth/me' && !context)) {
    throw new CanceledError('Rota de confirmação de sessão inválida');
  }
  const assertSnapshot = captureSession();
  const permit = () => {
    assertSnapshot();
    assertCurrent();
    return { url, method: methods[url], context: url === '/auth/me' ? null : context };
  };
  issued.add(permit);
  return { sessionPermit: permit, headers: { 'X-Session-Context': context } };
}

export function validateSessionPermit(config: AxiosRequestConfig) {
  const permit = config.sessionPermit;
  if (!permit) return null;
  if (!issued.has(permit)) throw new CanceledError('Confirmação de sessão inválida');
  issued.delete(permit);
  const allowed = permit();
  if (!Object.prototype.hasOwnProperty.call(methods, allowed.url) || config.url !== allowed.url || config.method !== methods[allowed.url] ||
      (allowed.url !== '/auth/me' && !allowed.context)) {
    throw new CanceledError('Rota de confirmação de sessão inválida');
  }
  return allowed;
}
